import { Component, Input, AfterViewInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { AppUiActions, TestTakerActions } from '../../../store/actions';
import * as fromRoot from '../../../store/reducers';
import * as Enum from '../../../dtos/enums';
import { TimerService } from '../../../services/timer.service';
import { TestTakerService } from '../../../services/test-taker.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'pause-screen',
    template: require('./pause-screen.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PauseScreenComponent implements AfterViewInit, OnDestroy {
    isVisibleSubscription: Subscription;
    testTakerPhotoUrl: string;

    constructor(
        private store: Store<fromRoot.State>,
        private testTakerService: TestTakerService,
        private timerService: TimerService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngAfterViewInit() {
        this.isVisibleSubscription = this.store.select(fromRoot.getIsPauseScreenVisible).subscribe(isVisible => {
            if (isVisible) {
                const testTakerInfo = this.testTakerService.testTakerInfo;
                this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                if (!this.timerService.isPaused()) {
                    this.timerService.pauseTimer();
                }
            }
            this.changeDetectorRef.detectChanges();
        });
    }

    ngOnDestroy() {
        this.isVisibleSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/pause-screen/pause-screen.component.ts